import React from 'react'
import { mobile } from './tokens'

interface MobileEmptyStateProps {
  icon?: React.ReactNode
  title: string
  description?: string
  action?: React.ReactNode
  className?: string
}

export function MobileEmptyState({
  icon,
  title,
  description,
  action,
  className = '',
}: MobileEmptyStateProps) {
  return (
    <div className={`${mobile.emptyWrap} ${className}`.trim()}>
      {icon && <div className={mobile.emptyIcon}>{icon}</div>}
      <h3 className={mobile.emptyTitle}>{title}</h3>
      {description && <p className={mobile.emptyBody}>{description}</p>}
      {action && <div className="mt-4 flex justify-center">{action}</div>}
    </div>
  )
}
